module.exports = __webpack_public_path__ + "static/media/web logos_Mettle Cap.80d2c5a4.jpg";